import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private image: any;
  private drafts: any;

  setImageData(data: any) {
    this.image = data;
  }

  getImageData() {
    return this.image;
  }

  setDraftData(data: any) {
    this.drafts = data;
  }

  getDraftData() {
    return this.drafts;
  }

  getMimeTypeFromBase64(base64String: string): string | null {
    const result = /^data:(.+);base64,/.exec(base64String);
    return result ? result[1] : null;
  }
}
